import { Box, Image, Text } from '@chakra-ui/react';
import usePeCompanyColor from 'hooks/modules/pe/usePeCompanyColor';
import { FC, Fragment } from 'react';

interface Props {
  company: PeCompanyShort;
}

const PeCompanyGridShortHeader: FC<Props> = ({ company }) => {
  const splittedName = company.name.split(' ');
  const bgColor = usePeCompanyColor(company.color, company.gradientColor);

  return (
    <Box
      pos="relative"
      h="100px"
      display="flex"
      borderTopRadius="16px"
      background={bgColor}
    >
      {company.logoSrc && (
        <Image
          position="absolute"
          src={company.logoSrc}
          right="20px"
          top="10px"
          w="80px"
          h="80px"
        />
      )}
      <Box py="10px" px="20px" alignSelf="flex-end">
        <Text color="white" fontWeight={700} fontSize="30px" noOfLines={2}>
          {splittedName.map((name, index) => (
            <Fragment key={index}>
              {name}
              {index < splittedName.length - 1 && <br />}
            </Fragment>
          ))}
        </Text>
      </Box>
    </Box>
  );
};

export default PeCompanyGridShortHeader;
